import { AuthContext } from '@excent-one/auth';
import { withArbitrIasAuthProvider } from '@excent-one/auth-arbitr-ias';
import { arbitrIasClientId, arbitrIasBffBasePath } from '../config';

const ArbitrIasAuthProvider = withArbitrIasAuthProvider(AuthContext, {
  clientId: arbitrIasClientId,
  bffBasePath: arbitrIasBffBasePath,
});

export default ArbitrIasAuthProvider;
